import React from 'react';
import { Text, Tabs, Bleed } from '@shopify/polaris';
import ModalTabs from './ModalTabs';

type ModalContentTabsLayoutProps<T extends string> = {
  title: string;
  tabs: {
    id: T;
    content: string;
  }[];
  children: React.ReactNode;
  tab: T;
  onTabChange: (tab: T) => void;
};

export const ModalContentTabsLayout = <T extends string>({
  title,
  tabs,
  children,
  onTabChange,
  tab,
}: ModalContentTabsLayoutProps<T>) => {
  const polarisTabs = tabs.map((tab) => ({
    id: tab.id,
    content: tab.content,
    accessibilityLabel: tab.content,
    panelID: tab.id,
  }));
  const handleTabChange = (selectedTabIndex: number) => {
    onTabChange(tabs[selectedTabIndex].id);
  };
  const selected = tabs.findIndex((t) => t.id === tab);

  return (
    <div className="flex h-full w-full flex-col gap-1">
      <Text as="h2" variant="headingMd" fontWeight="bold">
        {title}
      </Text>
      {tabs.length > 1 && <ModalTabs tabs={polarisTabs} selected={selected} onSelect={handleTabChange} />}
      <div className="h-full pt-2">{children}</div>
    </div>
  );
};
